// Helper type to extract values from an object type
type ValueOf<T> = T[keyof T];

export const FlowsListTrackingEvents = {
  FLOW_COPIED: 'flow copied',
  FLOW_DELETED: 'flow deleted',
} as const;

export const FlowWizardOptions = {
  AUTOMATION: 'automation',
  AUTOMATION_TEMPLATE: 'automation template',
  BASIC_CAMPAIGN: 'basic campaign',
  CAMPAIGN_FLOW: 'campaign flow',
  CAMPAIGN_TEMPLATE: 'campaign template',
  INFINITY_TEST_CAMPAIGN: 'create infinity test campaign',
  INFINITY_TEST_CAMPAIGN_CONTACT_SALES:
    'infinity test campaign - contact sales',
  INFINITY_TEST_CAMPAIGN_LEARN_MORE: 'infinity test campaign - learn more',
  LEGACY_CAMPAIGN: 'legacy campaign',
} as const;

export const FlowWizardTrackingEvents = {
  FLOW_WIZARD_COMPLETED: 'flow wizard completed',
} as const;

export const FlowActionTrackingEvents = {
  FLOW_ACTIONS_UPDATED: 'flow actions updated',
  FLOW_PREVIEW_SENT: 'preview message sent',
  INFINITY_TEST_CONVERT_CLICKED: 'convert to infinity test',
  INFINITY_TEST_BANNER_DISMISSED: 'infinity test banner dismissed',
} as const;

export const FlowTriggerTrackingEvents = {
  FLOW_TRIGGER_UPDATED: 'flow trigger updated',
} as const;

export const FlowActivationTrackingEvents = {
  ACTIVATE_FLOW_STARTED: 'activate flow started',
  BASIC_FLOW_CLICKED_SCHEDULE_OR_LAUNCH:
    'basic flow clicked schedule or launch',
  EDIT_BASIC_CAMPAIGN_FLOW: 'edit basic campaign flow',
  FLOW_ACTIVATED: 'flow activated',
  FLOW_BASIC_CAMPAIGN_CONVERTED: 'basic campaign converted to advanced flow',
  FLOW_DEACTIVATED: 'flow deactivated',
  FLOW_DEACTIVATION_SCHEDULED: 'flow deactivation scheduled',
  FLOW_DEACTIVATION_UNSCHEDULED: 'flow deactivation unscheduled',
  FLOW_SAVED: 'flow saved',
  FLOW_SCHEDULED: 'flow scheduled',
  FLOW_STOPPED: 'flow stopped',
  FLOW_UNSCHEDULED: 'flow unscheduled',
  UNDO_FLOW_LAUNCH: 'undo flow launch',
} as const;

export const FlowMigrationTrackingEvents = {
  FLOW_MIGRATIONS_MODAL_OPENED: 'flow migrations modal opened',
  FLOW_MIGRATIONS_REQUESTED: 'flow migrations requested',
} as const;

export const FlowTemplateEvents = {
  TEMPLATE_FAVORITED: 'template favorited',
  TEMPLATE_FILTERED: 'template filtered',
  TEMPLATE_LOADED_FROM_URL: 'template loaded from url',
  TEMPLATE_SELECTED: 'template selected',
  TEMPLATE_UNFAVORITED: 'template unfavorited',
} as const;

// Define FlowBuilderEventName as a union of all possible event values
export type FlowBuilderEventName =
  | ValueOf<typeof FlowActionTrackingEvents>
  | ValueOf<typeof FlowActivationTrackingEvents>
  | ValueOf<typeof FlowsListTrackingEvents>
  | ValueOf<typeof FlowTriggerTrackingEvents>
  | ValueOf<typeof FlowWizardTrackingEvents>
  | ValueOf<typeof FlowMigrationTrackingEvents>
  | ValueOf<typeof FlowTemplateEvents>;
